import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '@environments';

@Component({
  selector: 'via-footer',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  appVersion = environment.appVersion;
}
